import React from "react";
import { Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PersonIcon from "@mui/icons-material/Person";

import "./index.css";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { formatTimeAgo } from "utils/date";
import {
  changePatient,
  setScrollToNotesSection,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";
import { CLINIC_ROLES } from "static/constants";

export const NotificationItem = ({ notification, onRead }) => {
  const { message, createdAt, isRead, url, metadata } = notification;

  const timeAgo = formatTimeAgo(createdAt);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const isActive = url ? pathname.startsWith(url.split("?")[0]) : false;
  const { currentUser } = useSelector((state) => state.auth);

  const handleClick = () => {
    onRead(notification);
    if (metadata?.patient) {
      dispatch(
        changePatient({
          patientId: metadata?.patient?._id,
          serialNumber: metadata?.patient?.serial_number,
          ...(CLINIC_ROLES.includes(currentUser?.role) && {
            account: currentUser?.accounts?.[0],
          }),
        })
      );
      dispatch(setScrollToNotesSection(true));
      dispatch(toggleModal({ type: "patient", value: true }));
    } else if (url) {
      navigate(url);
    }
  };

  return (
    <div
      className={`notification-item${!isRead ? " notification-item--unread" : ""}${isActive ? " notification-item--active" : ""}`}
      onClick={handleClick}
    >
      <PersonIcon style={{ fontSize: "20px" }} />

      <div className="notification-item__content">
        <Typography className="notification-item__message">
          {message}
        </Typography>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {!isRead && (
          <FiberManualRecordIcon
            className="notification-item__indicator"
            color="secondary"
          />
        )}
        {timeAgo && (
          <Typography className="notification-item__time">{timeAgo}</Typography>
        )}
      </div>
    </div>
  );
};
